// src/SearchPage.tsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Search.css';
import HeaderComponent from '../../components/HeaderComponent';

interface SearchResult {
  valueCardID: number;
  modelName: string;
  category: string;
  modelLang: string;
}

const SearchPage: React.FC = () => {

  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [category, setCategory] = useState<string>('');
  const [language, setLanguage] = useState<string>('');
  const [others, setOthers] = useState<string[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const handleSearch = () => {
    setCategory('');
    setLanguage('');
    setOthers([])
    navigate(`/search?query=${searchQuery}`);
  };
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const response = await fetch(`/api/domain-models/search?${query.toString()}`);
        
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        setResults(data);
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError('An unknown error occurred');
        }
      }
    };

    fetchResults();
  }, [location.search]);

  const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCategory(event.target.value);
  };

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(event.target.value);
  };

  const handleOthersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setOthers(prev =>
      prev.includes(value) ? (prev.length === 1? [] : prev.filter(prev => prev !== value)) : [...prev, value]
    );

  };


  const handleApplyFilters = () => {
    const query = new URLSearchParams(location.search);
    if (category) query.set('category', category);
    if (language) query.set('language', language);
    if (others.length > 0) query.set('others', others.join(','))
      else query.set('others', 'default');
    navigate(`/search?${query.toString()}`);
  };

  const handleClearFilters = () => {
    setCategory('');
    setLanguage('');
    setOthers([]);
    setSearchQuery('');
    navigate('/search');
  };

  const handleGetDomainData = (cardID: number) => {
    navigate(`/getDomainData/${cardID}`);
  }


  return (
    <div className="search-page">
      <HeaderComponent />
      <div className='header'>
        <div className="search-bar">
          <input type="text" placeholder="Enter domain name or relevant domain parameter"
           value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} />
          <button className="search-button"  onClick={handleSearch}>Search domains</button>
      </div>
    </div>
      <div className="filters">
          <div className="filter-item">
            <label htmlFor="category">Category:</label>
            <select id="category" value={category} onChange={handleCategoryChange}>
              <option value="default">Select category</option>
              <option value="logistics">Logistics</option>
              <option value="robotics">Robotics</option>
              <option value="space exploration">Space exploration</option>
              <option value="healthcare">HealthCare</option>
              <option value="game theory">Game theory</option>
              <option value="manufacturing">Manufacturing</option>
              <option value="smart building">Smart building</option>
              <option value="autonomous vehicles">Autonomous vehicles</option>
              <option value="other">other</option>
            </select>
          </div>
          <div className="filter-item">
            <label htmlFor="language">Language:</label>
            <select id="language" value={language} onChange={handleLanguageChange}>
              <option value="default">Select language</option>
              <option value="PDDL">PDDL</option>
              <option value="HPDL">HPDL</option>
              <option value="HDDL">HDDL</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="filter-item">
            <label>Other filters:</label>
            <div className="checkbox-group">
              <label>
                <input
                  type="checkbox"
                  value='parsed'
                  checked={others.includes('parsed')}
                  onChange={handleOthersChange}
                />
                Is parseable
              </label>
              <label>
                <input
                  type="checkbox"
                  value='typed'
                  checked={others.includes('typed')}
                  onChange={handleOthersChange}
                />
                Is typed
              </label>
              <label>
                <input
                  type="checkbox"
                  value='scoreAbove30'
                  checked={others.includes('scoreAbove30')}
                  onChange={handleOthersChange}
                />
                Score above 30
              </label>
              <label>
                <input
                  type="checkbox"
                  value="cited"
                  checked={others.includes('cited')}
                  onChange={handleOthersChange}
                />
                Has citation
              </label>
            </div>
          </div>
          <button className="apply-button" onClick={handleApplyFilters}>
            Apply filters
          </button>
          <button className="clear-button" onClick={handleClearFilters}>
            Clear filters
          </button>
        </div>
      <div className="content">
        {error ? (
          <div className="error">{error}</div>
        ) : (
          results.map(result => (
            <div key={result.valueCardID} className="card-search">
              <h2>{result.modelName}</h2>
              <div className='card-data'> 
              <p><b>Category: </b>{result.category}</p>
              <p><b>Language:</b> {result.modelLang}</p>
              </div>
              <button className="search-button"  onClick={ () =>handleGetDomainData(result.valueCardID)}>More info</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SearchPage;
